import { FilterMatrixItem } from '../configurator/types';

export class FilterMatrix {
    private filteredResult: string;
    private filteredCharacteristics: FilterMatrixItem[];

    constructor(initialFilter: FilterMatrixItem[]) {
        this.filteredCharacteristics = initialFilter;
        this.filteredResult = '';
    }

    public AddFilter(filterMatrixItem: FilterMatrixItem): FilterMatrixItem[] {

        if (!this.filteredCharacteristics.find((x) => x.characteristicId === filterMatrixItem.characteristicId)) {
            this.filteredCharacteristics.push(filterMatrixItem);
        } else if (this.ValueChanged(filterMatrixItem)) {
            this.UpdateCharacteristicValue(filterMatrixItem);
        }

        return this.filteredCharacteristics;
    }

    public StringResult(filteredCharacteristics: FilterMatrixItem[]): string {
        const lastIndex = filteredCharacteristics.length - 1;
        for (const iterator of filteredCharacteristics) {
            this.filteredResult += iterator.characteristicId + '-' + iterator.valueDefinitionId;
            if (filteredCharacteristics.indexOf(iterator) < lastIndex) {
                this.filteredResult += '|';
            }
        }
        return this.filteredResult;
    }

    private ValueChanged(filterMatrixItem: FilterMatrixItem): boolean {
        const filteredItem = this.filteredCharacteristics.filter(
            (x) => x.characteristicId === filterMatrixItem.characteristicId)[0];

        if (filteredItem.valueDefinitionId === filterMatrixItem.valueDefinitionId) {
            return false;
        } else {
            return true;
        }
    }

    private UpdateCharacteristicValue(filterMatrixItem: FilterMatrixItem): void {
        const filteredItem = this.filteredCharacteristics.filter(
            (x) => x.characteristicId === filterMatrixItem.characteristicId)[0];

        const characteristicIndex: number = this.filteredCharacteristics.indexOf(filteredItem);
        this.filteredCharacteristics.splice(characteristicIndex, 1, filterMatrixItem);
    }
}